import React from "react";
import styles from "./Logo.module.css";

const Logo = ({ style }) => {
  return (
    <div className={`${styles.logo_container}`} style={style}>
      <img src={`${process.env.PUBLIC_URL}/images/wheel.png`} alt="ShipWheel Icon" className={`${styles.logo} wheel`} />
      <img src={`${process.env.PUBLIC_URL}/images/logo_text.gif`} alt="ShipWheel Text" className={`${styles.logo_text} fade_in`} />
    </div>
  );
};

export default Logo;
